"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utilities = require("../utilities");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var environment = 'unknown';
var applicationSettings = {
  development: {
    cdnUrl: 'aHR0cHM6Ly9hc3NldHMuemFnZm9yd2FyZC5jb20='
  },
  test: {
    cdnUrl: 'aHR0cHM6Ly9hc3NldHMuY2FydmFuYXRlY2guY29t'
  },
  uat: {
    cdnUrl: 'aHR0cHM6Ly9yZXNvdXJjZXMuY3Z1YXQuY29t'
  },
  production: {
    cdnUrl: 'aHR0cHM6Ly9hc3NldHMuY2FydmFuYS5jb20='
  },
  unknown: {
    cdnUrl: ''
  }
};

var ApplicationSettings = function () {
  function ApplicationSettings() {
    _classCallCheck(this, ApplicationSettings);
  }

  _createClass(ApplicationSettings, [{
    key: "setEnvironment",
    value: function setEnvironment(newEnvironment) {
      environment = newEnvironment;
    }
  }, {
    key: "decodeApplicationSetting",
    value: function decodeApplicationSetting(applicationSetting) {
      if (_utilities.IsServerSideRendering) {
        return null;
      }

      return atob(applicationSetting);
    }
  }, {
    key: "getApplicationSettings",
    value: function getApplicationSettings() {
      return environment in applicationSettings ? applicationSettings[environment] : applicationSettings.unknown;
    }
  }, {
    key: "getApplicationSetting",
    value: function getApplicationSetting(setting) {
      var settings = this.getApplicationSettings();
      return setting in settings ? this.decodeApplicationSetting(settings[setting]) : '';
    }
  }]);

  return ApplicationSettings;
}();

var _default = new ApplicationSettings();

exports.default = _default;
module.exports = exports.default;